var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-header"},[(_vm.path !== '')?_c('div',{staticClass:"top-arrow",on:{"click":_vm.goback}},[_c('md-icon',{attrs:{"name":"arrow-left","size":"md"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"top-tx"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"top-right"},[_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43bf183a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topback.vue
// module id = null
// module chunks = 